"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
query ticketRestriction($query: TicketRestrictionInput) {
    ticketRestriction(query:$query){
        eventId
        seasonId
        guestTicketCounts{
            teiMemberId
            count
            inValid
        }
    }
}
`;
exports.default = query;
//# sourceMappingURL=ticketRestriction.query.js.map